import { Box, Chip } from '@mui/joy';
import { useTranslation } from 'react-i18next';

import { AttributeType } from 'companySettings/enums';
import { IPartFinderAttributeValue } from 'companySettings/types';
import { Color, Size, Variant } from 'theme/enums';

import { getAttributeValueLabel } from './utils';

interface ISwatchProps {
  colorHex: string;
}

export const AttributeColorSwatch = ({ colorHex }: ISwatchProps) => (
  <Box
    sx={{
      width: 16,
      height: 16,
      borderRadius: 4,
      border: '1px solid',
      borderColor: 'neutral.300',
      backgroundColor: colorHex,
    }}
  />
);

interface IProps {
  value: IPartFinderAttributeValue;
  type: AttributeType;
  color?: Color;
  size?: Size;
}

// One value as a chip, with its swatch when it is a colour.
export const AttributeValueChip = ({ value, type, color = Color.NEUTRAL, size }: IProps) => {
  const { t } = useTranslation();

  return (
    <Chip
      variant={Variant.OUTLINED}
      color={color}
      size={size}
      startDecorator={
        AttributeType.COLOUR === type && <AttributeColorSwatch colorHex={value?.colorHex} />
      }
    >
      {getAttributeValueLabel(type, value, t)}
    </Chip>
  );
};
